module.exports = __webpack_public_path__ + "static/img/city-mob-gold-3.1f9137e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/city-mob-gold-3.png
// module id = 1246
// module chunks = 4